export const getVendorLabel = (vendor?: string | null) => {
  if (vendor && vendor.trim().length > 0) return vendor;
  return 'Unassigned';
};

export const getRequestNumber = (id: string) => {
  if (id.startsWith('MR-')) {
    return `#${id.replace('MR-', '')}`;
  }
  return id;
};
